// eslint-disable-next-line import/no-extraneous-dependencies
import { includes } from 'ramda'
import Vue from 'vue'
import {
  Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators'
import { firestoreAction } from 'vuexfire'
import {
  collection, get, getMany,
} from 'typesaurus'
import { UserType, UserCollection } from '../../types'
import LocationStore from './location'
import { db } from '../../firebase/init'
import store from '..'

const ListLocationCollection = collection<LocationListType>('locations')

const getUser = async (id: string) => {
  console.log('getting user: ', id)
  const data = await get(collection<UserType>('users'), id)
  if (data) {
    console.log('data here is: ', data)
    return data.data
  } return null
}

interface LocationListType {
  name: string
  avatar: string
  id: string
}

const Location = getModule(LocationStore)

@Module({ name: 'user', store, dynamic: true })
export default class User extends VuexModule {
  auth: UserType | undefined | null = undefined

  users: UserType[] = []

  userBound = false

  locationList = [] as LocationListType[]

  get multiUser () {
    if (!this.auth || !this.auth.multi) return false
    return true
  }

  get displayName () {
    if (!this.auth) return 'User Not Logged Ing'
    return `${this.auth.firstName} ${this.auth.lastName}`
  }

  get manager () {
    if (!store.state.location || !store.state.location.data || !store.state.location.data.group || !this.auth || !this.auth.authTags) {
      return false
    } return includes(`${store.state.location.data.group}-manager`, this.auth.authTags)
  }

  get uid () {
    if (!this.auth) return ''
    return this.auth.id
  }

  get userSelect () {
    if (this.multiUser) {
      return this.users.map(user => ({ text: `${user.firstName} ${user.lastName}`, value: user.id })).sort((a: any, b: any) => (a.text < b.text ? -1 : 1))
    } return [{ text: this.displayName, value: this.uid }]
  }

  get allUsers () {
    console.log('users is: ', this.users)
    return this.users.filter((user: UserType) => !user.authTags.includes(`${store.getters.group}-inactive`))
      .map(user => ({ text: `${user.firstName} ${user.lastName}`, value: user.id })).sort((a: any, b: any) => (a.text < b.text ? -1 : 1))
  }

  get allManagers () {
    return this.users.filter(user => includes(`${store.getters.group}-manager`, user.authTags)).map(user => ({ text: `${user.firstName} ${user.lastName}`, value: user.id })).sort((a: any, b: any) => (a.text < b.text ? -1 : 1))
  }

  @Mutation
  clearUser () {
    firestoreAction(
      ({ unbindFirestoreRef }) => {
        unbindFirestoreRef('auth')
      },
    )
    this.userBound = false
    this.auth = null
    this.locationList = [] as LocationListType[]
  }

  @Mutation
  bindUser (x: boolean = true) {
    this.userBound = x
  }

  @Mutation
  setUserNull () {
    this.auth = null
  }

  @Mutation
  setLocationList (locations: LocationListType[]) {
    console.log('binding list: ', locations)
    this.locationList = locations
  }

  @Action
  async setUser (uid: string) {
    console.log('setting user : ', uid)
    const authUser = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('auth', db.collection('users').doc(uid))) as Function
    const userResult = await authUser(this.context)
    if (userResult) {
      return this.bindUser()
    } return false
  }

  @Action
  async setLocationUsers (location: string) {
    console.log('setting user locations : ', location)
    const getAllUsers = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('users', db.collection('users').where('locations', 'array-contains', location))) as Function
    return getAllUsers(this.context)
  }

  @Action
  test123 () {
    const action = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('test', db.doc('locations/cobbswoodstock'))) as Function
    return action(this.context)
  }
}
